import {
  User,
  Mail,
  Phone,
  VenusAndMars,
} from "lucide-react";

import "./ProviderCards.css";

function OwnerInfoCard({ provider }) {

  const ownerDetails = [

    {
      icon: <User size={18} />,
      label: "Owner Name",
      value: provider.ownerName || "-",
    },

    {
      icon: <Mail size={18} />,
      label: "Email Address",
      value: provider.email || "-",
    },

    {
      icon: <Phone size={18} />,
      label: "Mobile Number",
      value: provider.phone || "-",
    },

    {
      icon: <VenusAndMars size={18} />,
      label: "Gender",
      value: provider.gender || "Not Specified",
    },

  ];

  return (

    <div className="provider-card">

      <h3 className="card-title">

        Owner Information

      </h3>

      <div className="info-list">

        {ownerDetails.map((item, index) => (

          <div
            className="info-row"
            key={index}
          >

            <div className="info-label">

              {item.icon}

              <span>

                {item.label}

              </span>

            </div>

            <div className="info-value">

              {item.value}

            </div>

          </div>

        ))}

      </div>

    </div>

  );

}

export default OwnerInfoCard;